module.exports = __webpack_public_path__ + "static/media/074-image.44d0edd7.svg";